const OverviewType = {
  TABLE: 'table',
  GROUPS_TABLES: 'group_table',
  KNOCKOUT: 'knockout',
} as const;

export default OverviewType;
